import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { UserAuthService } from '../services/user-auth.service';
import { Account } from '../models/auth/account.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AccountsService } from '../services/ui/accounts.service';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class UserAccountsResolver implements Resolve<Observable<Account[]>> {
	constructor(
		private router: Router,
		private userAuthService: UserAuthService,
		private accountsService: AccountsService,
		private jwt: JwtHelperService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const token = this.jwt.decodeToken();
		const platformTypeId = token ? parseInt(token[AuthService.PlatformTypeIdClaim], 10) : null;

		if (!token || !platformTypeId || isNaN(platformTypeId)) {
			const redirectPageNumber = parseInt(activatedRouteSnapshot.queryParamMap.get('page'), 10);
			const redirectPage = (!redirectPageNumber || isNaN(redirectPageNumber)) ? null : redirectPageNumber;
		    this.accountsService.redirectToUserAccountPage(redirectPage, { isAutoAccountRedirect: true })
			.subscribe(
				data=>{
					const x = data
				}
			);
			return NEVER;
		}

		return this.userAuthService
			.getAccounts(platformTypeId)
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.router.navigate(['/404']);
					return NEVER;
				})
			);
	}
}
